import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';

import { cartKey, removeCartItemOptions } from '@lib/api/options/cart';
import { MutationCallbackOptions } from '@lib/api/options/types';

export const useRemoveCartItem = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { mutateAsync: execute, isPending } = useMutation(
    removeCartItemOptions(),
  );

  const onRemoveCartItem = (
    id: string,
    options?: MutationCallbackOptions<Awaited<ReturnType<typeof execute>>>,
  ) =>
    execute(id, {
      onSuccess: () => {
        queryClient
          .invalidateQueries({ queryKey: cartKey })
          .catch(() => undefined);
        options?.onCompleted?.();
      },
      onError: (error) => {
        message.error('Não foi possível remover o item.');
        options?.onError?.(error);
      },
    });

  return { removeCartItem: onRemoveCartItem, removingCartItem: isPending };
};
